import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Button, Col, Form, Row, Space, Spin, Typography, Modal } from 'antd';
import {
	MerchantRequest,
	templeRequest,
} from '../../../../request/AuthRequest';
import useStore from '../../../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { displayFormats } from '../../../../config/Global';
const { Title } = Typography;
const RoutineForm = observer((props) => {
	const {
		handleChange,
		onFinish,
		id,
		form,
		initialValues,
		viewMode,
		getDarshanTimeData,
		loading,
	} = props;
	const {
		AUTH: { lookupKeyList },
	} = useStore();

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
			onChange={handleChange}
			initialValues={initialValues}
			disabled={viewMode}
		>
			<Spin spinning={viewMode ? !getDarshanTimeData : loading}>
				<Row gutter={24}>
					<Col span={24}>
						<Form.List name="templeTimingAddModelList">
							{(fields, { add, remove }) => {
								return (
									<>
										<Row align="bottom">
											{fields.map(({ key, name, ...restField }) => {
												const showConfirm = (name) => {
													Modal.confirm({
														title: "Are you sure you want to delete Darshan Timing " + form.getFieldValue('templeTimingAddModelList')[key].description + "?",
														okText: "Yes",
														cancelText: "No",
														okButtonProps: {
															style: {
																backgroundColor: "#ff6f00",
																borderColor: "#ff6f00",
																color: "#fff",
															},
														},
														onOk() {
															remove(name);
															handleChange();
														},
													});
												};

												return (
													<Col span={18} key={key}>
														<Space
															style={{
																display: 'flex',
																marginBottom: 10,
																width: '100%',
															}}
															align="end"
														>
															<InputComponent
																required
																type="select"
																showSearch={true}
																name={[name, 'timingType']}
																label="Select Darshan Type"
																placeholder="Select Darshan Type"
																onChange={handleChange}
																options={{
																	values: lookupKeyList,
																	value_key: 'lookupIntValue',
																	text_key: 'lookupValue',
																}}
																rules={templeRequest.darshanType}
																{...restField}
															/>

															<InputComponent
																required
																name={[name, 'description']}
																label="Description"
																placeholder="Enter Description"
																onChange={handleChange}
																rules={MerchantRequest.description}
															/>

															<InputComponent
																required
																type="time_picker"
																name={[name, 'time']}
																label="Select Time"
																placeholder="Select Time"
																onChange={handleChange}
																allowClear={false}
																format={displayFormats.TIME_FORMAT}
																rules={templeRequest.darshanTime}
																{...restField}
															/>

															<Button
																danger
																style={{ marginBottom: '12px' }}
																onClick={() => showConfirm(name)}
															>
																<FontAwesomeIcon icon={faMinus} />
															</Button>
														</Space>
													</Col>
												);
											})}

											{!viewMode && (
												<Form.Item>
													<Button
														type="primary"
														onClick={() => {
															add();
															handleChange();
														}}
														icon={<FontAwesomeIcon icon={faPlus} />}
														style={{ marginBottom: '12px' }}
													>
														Add Darshan Time
													</Button>
												</Form.Item>
											)}
										</Row>
									</>
								);
							}}
						</Form.List>
					</Col>
				</Row>
			</Spin>
		</Form>
	);
});

export default RoutineForm;
